import { useNavigate } from "react-router-dom";
import LogoIcon from "../../assets/icons/logo.png";
import RefreshIcon from "../../assets/icons/refresh.png";
import PlusIcon from "../../assets/icons/new_chat.png";

function Header({ onNewChat, sidebarOpen, onToggleSidebar }) {
  const navigate = useNavigate();

  return (
    <div className="header">
      <div className="header-left">
        <button
          type="button"
          className="header-back-btn"
          onClick={() => navigate("/user/dashboard")}
          aria-label="Back to dashboard"
          title="Back to dashboard"
        >
          {/* New inline SVG back icon (replaces old image asset) */}
          <svg className="header-back-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
            <path d="M15 6 L9 12 L15 18" stroke="#0f52ba" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" fill="none" />
          </svg>
        </button>
        {!sidebarOpen && (
          <button
            type="button"
            className="header-open-sidebar-btn"
            onClick={onToggleSidebar}
            aria-label="Open sidebar"
            title="Open sidebar"
          >
            {/* Inline right-pointing chevron SVG (replaces previous image) */}
            <svg className="header-open-sidebar-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
              <path d="M9 6 L15 12 L9 18" stroke="#0f52ba" bg-transparent strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
            </svg>
          </button>
        )}
        <img src={LogoIcon} alt="Fitnova" className="header-logo" />
        <div className="header-text">
          <div className="header-title">Fitnova</div>
          <div className="header-subtitle">Your AI Wellness Assistant</div>
        </div>
      </div>

      <div className="header-right">
        <button
          type="button"
          className="refresh-btn"
          onClick={() => window.location.reload()}
          aria-label="Refresh"
          title="Refresh"
        >
          {/* Inline refresh SVG — two curved arrows forming a circle; stroke color matches primary blue */}
          <svg className="refresh-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" width="18" height="18">
            <path d="M21 12a9 9 0 1 0-3.01 6.01" fill="none" stroke="#0f52ba" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
            <polyline points="21 3 21 9 15 9" fill="none" stroke="#0f52ba" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
        <button type="button" className="new-chat-btn" onClick={onNewChat}>
          <img src={PlusIcon} alt="Plus" className="plus-icon" />
          New Chat
        </button>
      </div>
    </div>
  );
}

export default Header;
